import sdl from '@jds/react-generated-sdl/JDSDesktopBottomSheetInternal';
import type { JDSDesktopBottomSheetInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDesktopBottomSheetInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'overlay',
    controlType = 'normal',
    isCustom = false,
    close = true,
    primaryCtaDisabled = false,
    secondaryCtaDisabled = false,
    ariaLabel = 'Bottom Sheet Content',
    cancelButtonAriaLabel = 'Close Modal',
    backButtonAriaLabel = 'Click to go Back',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      controlType,
      isCustom,
      close,
      primaryCtaDisabled,
      secondaryCtaDisabled,
      ariaLabel,
      cancelButtonAriaLabel,
      backButtonAriaLabel,
      ...rest
    },
    'JDSDesktopBottomSheetInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DesktopBottomSheetInternal = withLogic(
  Component
) as React.FC<JDSDesktopBottomSheetInternalProps> & { slotName?: string };

DesktopBottomSheetInternal.displayName = 'DesktopBottomSheetInternal';
DesktopBottomSheetInternal.slotName = 'jds_desktop_bottom_sheet_internal';

export { DesktopBottomSheetInternal, type JDSDesktopBottomSheetInternalProps };
